import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { Page } from ".";
import { scCatchServiceException } from "../../annotations";
import { OauthApplication } from "./dtos/OauthApplication";

const OAUTH_APPLICATION_SERVICE = `${Constants.API_URL}/bedrock/oauth_applications`;

export class OauthApplicationServices {
  @scCatchServiceException()
  static async create(name: string, scopes: string | string[]): Promise<OauthApplication> {
    const url = OAUTH_APPLICATION_SERVICE;
    const { data } = await axios.post<OauthApplication>(url, { name, scopes });
    return data;
  }

  @scCatchServiceException()
  static async getAll(
    search?: string,
    page = 1,
    perPage = 15,
    sort?: string,
    order?: "asc" | "desc"
  ): Promise<Page<OauthApplication>> {
    const url = OAUTH_APPLICATION_SERVICE;
    const { data } = await axios.get<Page<OauthApplication>>(url, {
      params: { search, page, perPage, sort, order },
    });
    return data;
  }

  @scCatchServiceException()
  static async get(id: number): Promise<OauthApplication> {
    const url = `${OAUTH_APPLICATION_SERVICE}/${id}`;
    const { data } = await axios.get<OauthApplication>(url);
    return data;
  }

  @scCatchServiceException()
  static async update(id: number, name?: string, scopes?: string | string[]): Promise<OauthApplication> {
    const url = `${OAUTH_APPLICATION_SERVICE}/${id}`;
    const { data } = await axios.patch(url, { name, scopes });
    return data;
  }

  @scCatchServiceException()
  static async renewSecret(id: number): Promise<OauthApplication> {
    const url = `${OAUTH_APPLICATION_SERVICE}/${id}`;
    const { data } = await axios.patch(url, { renewSecret: true });
    return data;
  }

  @scCatchServiceException()
  static async delete(id: number): Promise<void> {
    const url = `${OAUTH_APPLICATION_SERVICE}/${id}`;
    await axios.delete(url);
  }
}
